import { createContext, useContext } from 'react'
import type { BootstrapData } from '../types'

export const AppContext = createContext<BootstrapData | null>(null)

export function useApp() {
  const value = useContext(AppContext)
  if (!value) throw new Error('AppContext is not ready')
  return value
}

export function usePermission(permission: string) {
  return useApp().permissions.includes(permission)
}
